// import api from "../../../../../common/dependencies/utils/Api";
import api from "../../common/dependencies/utils/Api";
import { CONTACT_SUBMIT_DATA } from "../../common/constants/ApplicationUrl";

export const ContactSubmitService = {
  contactSubmitData(params) {
    return api
      .POST(`${CONTACT_SUBMIT_DATA}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          
          return response.data;
        } else {
          return { status: false };
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      });
  },
};
